import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Typography, Row, Col } from 'antd';
import OverviewCardPlan from './OverviewCardPlan';
import OverviewCardOrders from './OverviewCardOrders';
import OverviewCardSumary from './OverViewCardSummary';
// css
import 'assets/styles/overview.scss';
import OverviewCardSettlement from './OverviewCardSettlement';

const { Title } = Typography;

const Overview = () => {

	const authUser = useSelector((state) => state.auth.authUser);
	
	return (
		<div className="overview-content">
			<div className="overview-header">
				<Title level={3}>Hello {authUser?.full_name},</Title>
				<Title level={2}>Welcome back 👋</Title>
			</div>
			<div className="overview-main">
				<Row gutter={[24, 24]}>
					<Col xs={24} sm={24} md={24} lg={16} xl={16}>
						<OverviewCardOrders />
					</Col>
					<Col xs={24} sm={24} md={24} lg={16} xl={16} className="mt-24">
						<OverviewCardSettlement />
					</Col>
				</Row>
			</div>
		</div>
	);
};

export default Overview;
